import EmptyIcon from '@assets/images/earlyWarning/chat-icon-v2.svg';
import { MotionImage, MotionText } from '@shared/atoms';
import { motion } from 'framer-motion';
import React, { useMemo } from 'react';
import styles from './styles.module.scss';

export type FeedType = 'yourself' | 'organisation' | 'community';

interface NoDataPlaceholderProps {
  feedType: FeedType;
}

const NoDataPlaceholderComponent: React.FC<NoDataPlaceholderProps> = ({ feedType }) => {
  const messages = useMemo(
    () => ({
      yourself: 'No thoughts available',
      organisation: 'No speak ups available',
      community: 'No community posts available.',
    }),
    [],
  );

  return (
    <motion.div
      className={styles.noDataPlaceholder}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4 }}
    >
      <div className={styles.noDataContainer}>
        <MotionImage src={EmptyIcon} alt="" aria-hidden="true" className={styles.emptyIcon} />
        <MotionText as="text" text={messages[feedType]} className={styles.noDataMessage} />
      </div>
    </motion.div>
  );
};

export const NoDataPlaceholder = React.memo(NoDataPlaceholderComponent);

NoDataPlaceholder.displayName = 'NoDataPlaceholder';
